import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  CardContent,
  Card,
  CardHeader,
  CardActions,
  ListItem,
  ListItemText,
  Avatar,
  Grid,
  IconButton,
  Tooltip,
  Button,
  CircularProgress,
} from '@material-ui/core';
import {
  Info,
  Add,
} from '@material-ui/icons';

import DashboardSelector from '../../../DashboardPage/DashboardSelector';
import DashboardList from '../DashboardsList';
import DashboardForm from '../DashboardForm';
import DisplayMessage from '../../../../widgets/DisplayMessage';

import styles from './styles';

const noDashboardSelected = () => ({ name: 'Select a dashboard' });

export class DashboardsCardComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { selectedDashboard: noDashboardSelected() };
  }

  onDashboardUpdate = (updatedDashboard) => {
    this.setState({ selectedDashboard: updatedDashboard });
  }

  startCreateNewDashboard = () => {
    this.setState({
      selectedDashboard: {
        allValid: false,
        id: -1,
        name: '',
        organizationExposed: false,
        directLinkName: '',
        defaultView: 'list',
        dashboardData: {
          endDate: null,
          includeArchived: false,
          includeComplete: false,
          searchText: '',
          sortStartDateDesc: true,
          startDate: null,
          statusIds: [],
          tagConditions: [],
        },
      },
    });
  }

  selectDashboard = (selectedDashboard) => {
    this.setState({ selectedDashboard });
  }

  cancelSelectedDashboard = () => {
    this.setState({ selectedDashboard: noDashboardSelected() });
  }

  saveSelectedDashboard = () => {
    this.props.onSave(this.state.selectedDashboard);
    this.setState({ selectedDashboard: noDashboardSelected() });
  }

  deleteSelectedDashboard = (id) => {
    this.props.onDelete(id);
    if (id === this.state.selectedDashboard.id) {
      this.setState({ selectedDashboard: noDashboardSelected() });
    }
  }

  render() {
    const {
      classes,
      fullScreen,
      dashboards,
      eventData,
      isAdmin,
      userEmail,
      isLoadingDashboards,
    } = this.props;
    const { selectedDashboard } = this.state;

    const filteredDashboards = dashboards.filter((d) => d.id >= 0
      && d.createdByEmail.toLowerCase() === userEmail.toLowerCase());

    return (
      <Card>
        <CardHeader
          title="Dashboards"
          subheader="Manage the dashboards you have created"
          action={(
            <Tooltip title="Create new dashboard">
              <IconButton aria-label="Add" onClick={this.startCreateNewDashboard}>
                <Add />
              </IconButton>
            </Tooltip>
          )}
        />
        <CardContent>
          <Grid container spacing={3} className={classes.container}>
            <Grid item xs md={4} className={classes.dashboardListContainer}>
              {
                isLoadingDashboards
                && (
                  <div className={classes.progressContainer}>
                    <CircularProgress className={classes.progress} />
                  </div>
                )
              }
              {
                filteredDashboards.length === 0
                  && (
                    <ListItem className={classes.noDashboardsDisclaimer}>
                      <Avatar>
                        <Info />
                      </Avatar>
                      <ListItemText primary="No dashboards found" />
                    </ListItem>
                  )
              }

              {
                filteredDashboards.length > 0 && (
                  fullScreen
                    ? (
                      <DashboardSelector
                        dashboards={filteredDashboards}
                        selectedDashboard={selectedDashboard}
                        onDashboardChange={this.selectDashboard}
                        showAllEventsDashboard={false}
                      />
                    )
                    : (
                      <DashboardList
                        dashboards={filteredDashboards}
                        selectedDashboard={selectedDashboard}
                        onDashboardChange={this.selectDashboard}
                        onDashboardDelete={this.deleteSelectedDashboard}
                      />
                    )
                )
              }
            </Grid>
            <Grid item xs={12} md={6} className={classes.dashboardEditContainer}>
              {
                (!isLoadingDashboards && filteredDashboards.length === 0 && !selectedDashboard.id)
                  ? (
                    <DisplayMessage
                      title="You do not have any dashboards"
                      subTitle="Create one to get started"
                      icon="error_outline"
                    />
                  )
                  : (
                    <DashboardForm
                      isAdmin={isAdmin}
                      dashboard={selectedDashboard}
                      handleDashboardUpdate={this.onDashboardUpdate}
                      eventData={eventData}
                    />
                  )
              }
            </Grid>
          </Grid>
        </CardContent>
        {
          selectedDashboard.id
          && (
            <CardActions className={classes.cardActions}>
              <Button color="default" onClick={this.cancelSelectedDashboard}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={this.saveSelectedDashboard}
                color="primary"
                disabled={!selectedDashboard.allValid}
              >
                Save
              </Button>
            </CardActions>
          )
        }
      </Card>
    );
  }
}

DashboardsCardComponent.propTypes = {
  classes: PropTypes.object,
  fullScreen: PropTypes.bool,
  dashboards: PropTypes.array,
  isAdmin: PropTypes.bool,
  userEmail: PropTypes.string,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  isLoadingDashboards: PropTypes.bool,
  eventData: PropTypes.array,

};

DashboardsCardComponent.defaultProps = {
  classes: {},
  fullScreen: false,
  dashboards: [],
  eventData: [],
  isAdmin: false,
  userEmail: '',
  onSave: () => {},
  onDelete: () => {},
  isLoadingDashboards: true,
};

export default (withStyles(styles, { withTheme: true })(DashboardsCardComponent));
